import {GetterTree, MutationTree, ActionTree} from 'vuex'
import {LocationState} from '@/store/types'

type LocationGetter = GetterTree<LocationState, any>
type LocationMutation = MutationTree<LocationState>
type LocationAction = ActionTree<LocationState, any>

const state: LocationState = {
  location: null,
}


const getters: LocationGetter = {
  location: (state) => state.location,
}

const mutations: LocationMutation = {
  setLocation: (state, payload) => {
    state.location = Object.assign({}, payload)
  },
}

const actions: LocationAction = {

}

export default {
  state,
  getters,
  mutations,
  actions,
}
